import { injectStrict } from '@/injection/injectStrict.ts';
import { ApiKey } from '@/injection/keys.ts';
import { ApiRequestParams } from '@/types/api.type.ts';
import {
    CarPlacementSaleReportsPaginator,
    CarPlacementSaleReportsPaginatorSchema,
    CarPlacementSaleReportsRequestFilter,
    ReportAuctionsPaginator,
    ReportAuctionsPaginatorSchema,
    ReportAuctionsRequestFilter,
    ReportBid,
    ReportBidsSchema,
} from '@/types/report.type.ts';

class ReportRepository
{
    private $Api: any;

    constructor() {
        this.$Api = injectStrict(ApiKey);
    }

    public getBidReportAuctions(requestFilter?: ReportAuctionsRequestFilter): Promise<ReportAuctionsPaginator>
    {
        const requestParams: ApiRequestParams = {
            query: requestFilter,
        };

        return new Promise((resolve) => {
            this.$Api.callNew('GetBidReportAuctions', requestParams)
                .then(({ data }: any) => {
                    const parsedReportAuctionsPaginator = ReportAuctionsPaginatorSchema.parse(data);
                    const reportAuctionsPaginator: ReportAuctionsPaginator = parsedReportAuctionsPaginator as unknown as ReportAuctionsPaginator;

                    resolve(reportAuctionsPaginator);
                });
        });
    }

    public getBidReportAuction(id: number): Promise<ReportBid[]>
    {
        const requestParams: ApiRequestParams = {
            segments: { id },
        };

        return new Promise((resolve) => {
            this.$Api.callNew('GetBidReportByAuction', requestParams)
                .then(({ data }: any) => {
                    const parsedBids = ReportBidsSchema.parse(data);
                    const bids: ReportBid[] = parsedBids as unknown as ReportBid[];

                    resolve(bids);
                });
        });
    }

    public getCarsPostingAndSellingReports(requestFilter?: CarPlacementSaleReportsRequestFilter): Promise<CarPlacementSaleReportsPaginator>
    {
        const requestParams: ApiRequestParams = {
            query: requestFilter,
        };

        return new Promise((resolve) => {
            this.$Api.callNew('GetCarsPostingAndSellingReports', requestParams)
                .then(({ data }: any) => {
                    const parsedReports = CarPlacementSaleReportsPaginatorSchema.parse(data);
                    const reports: CarPlacementSaleReportsPaginator = parsedReports as unknown as CarPlacementSaleReportsPaginator;

                    resolve(reports);
                });
        });
    }

    public regenerateCarsPostingAndSellingReport(id: number): Promise<void>
    {
        const requestParams: ApiRequestParams = {
            segments: { id },
        };

        return new Promise((resolve, reject) => {
            this.$Api.callNew('RegenerateCarsPostingAndSellingReport', requestParams)
                .then(() => resolve())
                .catch(() => reject());
        });
    }
}

export default ReportRepository;
